/* AMADEUS BACK1 (2026-11-03). A customer who opens a product from Boost's search or collection results
   and presses Back lands at the top of the results and loses their place (Barbara, beta part 2, D-043).
   Cause: Boost sets history.scrollRestoration to "manual" and draws the cards after the page loads, so
   the browser never puts the scroll position back. This remembers the place per address in
   sessionStorage while the customer scrolls, and on a back or forward navigation puts it back once
   Boost has drawn enough page to scroll to. A fresh visit to the same address (a new search, a link)
   starts at the top as before. Loaded on search and collection pages only (layout/theme.liquid). */
(function () {
  'use strict';
  /* Boost rewrites the address as it draws (?q=Ave+Maria&page=2 becomes ?page=2&q=Ave+Maria), so the
     key sorts the query and is computed fresh each time, never once at load. */
  function key() {
    var p = new URLSearchParams(location.search);
    p.sort();
    return 'aa-back:' + location.pathname + '?' + p.toString();
  }
  var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || null;
  var navType = nav ? nav.type : (performance.navigation && performance.navigation.type === 2 ? 'back_forward' : 'navigate');
  var saving = false;

  function save() {
    if (saving) return;
    saving = true;
    setTimeout(function () {
      saving = false;
      try { sessionStorage.setItem(key(), String(Math.round(window.scrollY || window.pageYOffset || 0))); } catch (e) { /* storage off */ }
    }, 150);
  }
  window.addEventListener('scroll', save, { passive: true });

  function restore(y) {
    var started = Date.now();
    (function tick() {
      var drawn = document.querySelector('.boost-sd__product-item, .boost-sd__product-list');
      var tall = document.documentElement.scrollHeight >= y + window.innerHeight * 0.5;
      if (drawn && tall) {
        window.scrollTo(0, y);
        return;
      }
      if (Date.now() - started < 10000) {
        setTimeout(tick, 100);
      } else if (drawn) {
        window.scrollTo(0, y);
      }
    })();
  }

  if (navType === 'back_forward' || navType === 'reload') {
    var y = 0;
    try { y = parseInt(sessionStorage.getItem(key()) || '0', 10); } catch (e) { y = 0; }
    if (y > 0) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { restore(y); });
      } else {
        restore(y);
      }
    }
  }
})();
